import * as action from './actionsTypes'

const color1 = 'white';
const color2 = 'gray';

export const logIn = (data) => ({
    type: action.USER_LOGGED_IN,
    payload: {
        userData: {
            id:data.id,
            name:data.name,
            username:data.username,
            token:data.token,
            adminDaily: data.adminDaily,
            adminNumeration:data.adminNumeration,

                    adminAll:data.adminAll,
                    adminDailyData:data.adminDailyData,
                    stat:data.stat,
                    allStat: data.allStat,
                    edit0600:data.edit0600,
                    edit0800:data.edit0800,

        },
        autoModal: {

            autoModalIsOpen: false
        }
    }
})

export const logOut = () => ({
    type:action.USER_LOGGED_OUT

})

export const selectKorisnik = (poziv) => ({
    type:action.KORISNIK_SELECTED,
    payload: {
        korisnik: {
            korisnik: poziv
        }
    }
})


export const setActiveTKC = (net) => ({
    type:action.NET_SET,
    payload: {
        TKC: {
            tkc: net.tkc,
            pozivni: net.pozivni
        }
    }
})



export const toggleSomeValue = (value) => ({
    type: action.TOGGLE_VARIABLE,
    payload: {
        value
    }
})

export const openAutoModal = () => ({
    type: action.AUTO_MODAL_OPENED,
    payload: {
        autoModal:{
            open:true

        }
    }
})

export const closeAutoModal = () => ({
    type:action.AUTO_MODAL_CLOSED,
    payload: {
        autoModal: {

            open:false
        }
    }
})

export const isLoading = () => ({
    type:action.IS_LOADING,
    payload: {
        loader: {
            isLoading:true

        }
    }
})

export const isNotLoading = () => ({
    type:action.IS_NOT_LOADING,
    payload: {
        loader: {

            isLoading:false
        }
    }
})


export const openMenu = () => ({
    type: action.MENU_OPENED,
    payload: {
        menu:{
            open:true

        }
    }
})

export const closeMenu = () => ({
    type:action.MENU_CLOSED,
    payload: {
        menu: {

            open:false
        }
    }
})
